export const countriesLookupId = 231;
export const sportsLookupId = 99;
